export default "__VITE_ASSET__C0eH1dEa__"